var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{attrs:{"align":"center"}},[_c('img',{attrs:{"src":require("../../../assets/img/logo.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }